import { Loader } from '../Widgets';
import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from "react-redux";
import { Session } from 'service';
import ArthaGateway from 'service/ArthaGateway';
import { RootState } from 'store/store';
import AsyncSelect from 'react-select/async';
import moment from 'moment';

export const Indents = () => {
    const appdata = useSelector((state: RootState) => state.appdata);
    const [session, setSession] = useState<Session>();
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [productionPlants, setProductionPlants] = useState<Array<any>>([]);
    const [productionPlantId, setProductionPlantId] = useState<number>(0);
    const [partyId, setPartyId] = useState<number>(0);
    const [partyName, setPartyName] = useState<string>("");
    const [durationId, setDurationId] = useState<string>(moment().format("YYYY-MM"));
    const [durations, setDurations] = useState<Array<{ value: string; label: string }>>([]);
    const [indents, setIndents] = useState<Array<any>>([]);
    const [status, setStatus] = useState<number>(1);
    const [voucherNumber, setVoucherNumber] = useState<string>("");
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [totalPages, setTotalPages] = useState<number>(1);
    const [isInitializing, setIsInitializing] = useState<boolean>(true);

    useEffect(() => {
        if (appdata.profile) {
            setSession(appdata.profile.profile);
        }
    }, [appdata]);

    useEffect(() => {
        if (session != null) {
            loadDurations();
        }
    }, [session]);

    useEffect(() => {
        loadIndents();
    }, [pageNumber]);

    useEffect(() => {
        if (productionPlants.length > 0) {
            setProductionPlantId(productionPlants[0].id);

            let savedParams = localStorage.getItem('indentLoadingSearchParams');
            if (savedParams) {
                let params = JSON.parse(savedParams);
                if (params.durationId) { setDurationId(params.durationId); }
                if (params.partyId) { setPartyId(params.partyId); }
                if (params.productionPlantId) { setProductionPlantId(params.productionPlantId); }
                if (params.status) { setStatus(params.status); }
                if (params.voucherNumber) { setVoucherNumber(params.voucherNumber); }
            }

            // Small delay to show the loading indicator & parameter values to propagate
            setTimeout(() => {
                setIsInitializing(false);
            }, 500);
        }
    }, [productionPlants]);

    useEffect(() => {
        if (isInitializing) { return; }

        setIndents([]);
        if (pageNumber > 1) {
            setPageNumber(1);
        }
        else {
            loadIndents();
        }
    }, [isInitializing, productionPlants, durationId, partyId, productionPlantId, status, voucherNumber]);

    const loadDurations = () => {
        let months: Array<{ value: string; label: string }> = [];
        months.push({ value: "0", label: "Today" });
        months.push({ value: "1", label: "Yesterday" });
        months.push({ value: "2", label: "This Week" });
        months.push({ value: "3", label: "Last Week" });
        months.push({ value: "12", label: "Last 5 days" });
        months.push({ value: "13", label: "Last 5-7 days" });
        months.push({ value: "14", label: "Last 8-10 days" });
        months.push({ value: "15", label: "Last 10-15 days" });
        months.push({ value: "16", label: "Last 15-30 days" });
        months.push({ value: "17", label: "Before 30 days" });
        months.push({ value: "4", label: "This month" });
        months.push({ value: "5", label: "Last month" });
        months.push({ value: "6", label: "Last 2 month" });
        months.push({ value: "7", label: "Last 3 month" });
        months.push({ value: "8", label: "Last Year" });
        months.push({ value: "9", label: "Last 1 Year" });
        let current = moment();
        for (let i = 0; i < 6; i++) {
            months.push({ value: current.format("YYYY-MM"), label: current.format("MMMM YYYY") });
            current = current.subtract(1, 'month');
        }
        setDurations(months);
        loadProductionPlants();
    }

    const loadProductionPlants = async () => {
        let cachedValue = sessionStorage.getItem('productionPlants');
        if (cachedValue) {
            let plants = JSON.parse(cachedValue);
            setProductionPlants(plants);
        }
        const plants = await ArthaGateway.getProductionPlants();
        sessionStorage.setItem('productionPlants', JSON.stringify(plants));
        setProductionPlants(plants);
    };

    const onSearchParty = (inputValue: string) => {
        return new Promise<any[]>(async (resolve) => {
            const data = await ArthaGateway.getParty(inputValue, 'Customer');
            var mappedData = data.entries.map(function (party) {
                return {
                    value: party,
                    label: party.name + (party.gstin ? ' (' + party.gstin + ')' : '')
                };
            });
            resolve(mappedData);
        });
    };

    const loadIndents = async () => {
        if (isInitializing) { return; }

        if(voucherNumber.trim().length > 0 && voucherNumber.trim().length < 10) { return; }

        let searchParams = {
            durationId: durationId,
            partyId: partyId,
            productionPlantId: productionPlantId,
            status: status,
            voucherNumber: voucherNumber
        }
        localStorage.setItem('indentLoadingSearchParams', JSON.stringify(searchParams));

        setIsLoading(true);
        let data = await ArthaGateway.getLoadingIndents(durationId, '', '', partyId, productionPlantId, status, voucherNumber, pageNumber, 20);
        setIndents(data.entries);
        setTotalPages(data.totalPages);
        setIsLoading(false);
    }

    return (
        <div className='page page-dealers'>
            <div className="container-fluid min-vh-100 p-2">
                <div className='row mb-3'>
                    <div className="col-12 mb-2">
                        <h2>Loading Indents</h2>
                    </div>
                </div>
                <div className='row mb-3'>
                    <div className="col-12 col-md-4 mb-2">
                        <label>Duration</label>
                        <select className="form-control" value={durationId} onChange={(e) => { setDurationId(e.target.value); }}>
                            {durations.map((duration) => (
                                <option key={duration.value} value={duration.value}>{duration.label}</option>
                            ))}
                        </select>
                    </div>
                    <div className="col-12 col-md-4 mb-2">
                        <label>Production Plant</label>
                        <select className="form-control" value={productionPlantId} onChange={(e) => { setProductionPlantId(parseInt(e.target.value)); }}>
                            <option value={0}>-- All Production Plants --</option>
                            {productionPlants.map((plant) => (
                                <option key={plant.id} value={plant.id}>{plant.name}</option>
                            ))}
                        </select>
                    </div>
                    <div className='col-12 col-md-4 mb-2'>
                        <label>Indent Number</label>
                        <input type="text" className='form-control' value={voucherNumber} onChange={(e) => { 
                            setVoucherNumber(e.target.value); 
                        }} placeholder="Indent Number" />
                    </div>
                    <div className='col-12 col-md-4 mb-2'>
                        <label>Status</label>
                        <select className="form-control" value={status} onChange={(e) => { setStatus(parseInt(e.target.value)); }}>
                            <option value={1}>Pending</option>
                            <option value={2}>Loaded</option>
                            <option value={3}>Partially Loaded</option>
                        </select>
                    </div>
                    <div className="col-12 col-md-4 mb-2">
                        <label>Party</label>
                        <AsyncSelect
                            cacheOptions
                            onChange={(newValue: any) => {
                                if (newValue) {
                                    setPartyId(newValue.value.id);
                                    setPartyName(newValue.value.name);
                                } else {
                                    setPartyId(0);
                                    setPartyName("");
                                }
                            }}
                            loadOptions={onSearchParty}
                            value={partyId == 0 ? null : { value: partyId, label: partyName }}
                            isClearable
                            classNamePrefix="react-select"
                            menuPortalTarget={document.body}
                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            placeholder="Select a party..."
                        />
                    </div>
                </div>
                <div className='row mb-3'>
                    <div className="col-12">
                        {isLoading && <Loader />}
                    </div>
                    {!isLoading && !isInitializing && indents.length == 0 &&
                        <div className='col-12'>
                            <div className='alert alert-info'>No indents found</div>
                        </div>
                    }
                    {!isLoading && !isInitializing && indents.length > 0 &&
                        <>
                            {indents.map((indent) => (
                                <div className="col-12 col-md-6 col-lg-4 mb-2" key={indent.id}>
                                    <div className="card">
                                        <div className="card-header bg-dark text-white">
                                            <div className="card-title"><h2>{indent.voucherNumber}</h2></div>
                                        </div>
                                        <div className="card-body p-0">
                                            <ul className="list-group list-group-flush">
                                                <li className="list-group-item py-1">
                                                    <div>Date: </div>
                                                    <div className="fw-bold">{moment(indent.date).format("DD MMM YYYY")}</div>
                                                </li>
                                                <li className="list-group-item py-1">
                                                    <div>Production Plant: </div>
                                                    <div className="fw-bold">{indent.plantName}</div>
                                                </li>
                                                <li className="list-group-item py-1">
                                                    <div>Party: </div>
                                                    <div className="fw-bold">{indent.party.name}</div>
                                                </li>
                                                <li className="list-group-item py-1">
                                                    <div>Destination:</div>
                                                    <div className="fw-bold">{indent.shippingCity}</div>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="card-footer">
                                            <a className='btn btn-sm btn-dark' href={`/indents/${indent.id}`}>View Details</a>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </>
                    }
                </div>
            </div>
        </div>
    );
};